import { loadStripe, Stripe } from '@stripe/stripe-js';

// Create Stripe promise at module level to ensure consistency and avoid multiple initializations
export const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ''
);

// Export type for better TypeScript support
export type StripePromise = Promise<Stripe | null>;
